import React, { Component, useRef } from "react";
import p5 from "p5";
import SpaceMono from "../assets/fonts/SpaceMono-Regular.ttf";
import Revolver from "../assets/obj/Revolver.obj";

export default class App extends Component {
  //React ref for div reference we pass into p5
  sketchRef = React.createRef();

  //P5 instance mode
  initSketch = (p) => {
    let canvas;

    let w = window.innerWidth;
    let h = window.innerHeight;

    let rw = w * 0.65;

    let font;

    let revolver;

    let angle = 0;

    // const canvasRef = useRef(null);
    let ellipses = [];

    let a = "Rodrigo Paestra,\nthe same statue of death\nshe had seen earlier,";
    let b = "was waiting for this dawn,\nand to be killed.";

    let loaded = false;
    p.preload = () => {
      font = p.loadFont(SpaceMono, font);
      revolver = p.loadModel(Revolver, function() {
        loaded = true;
      });
    };

    p.setup = () => {
      //store width and height
      //setup canvas and init values here
      canvas = p.createCanvas(rw, h, p.WEBGL);

      //normal canvas
    };

    p.draw = () => {

      if (!loaded) {
        // 로딩이 완료되지 않았으면 흰색 배경을 그립니다.
        p.background("#ffffff");
        return;
      }

      p.background("#83A9F4");
      p.push();
      p.directionalLight(255, 255, 255, 0, 0, 1);
      p.rotateX(angle + p.mouseX * 0.005);
      p.rotateY(angle * 0.5 - p.mouseY * 0.005);
      p.rotateZ(angle * 0.7 + p.mouseY * 0.005);
      p.scale(50);
      p.noStroke();
      p.model(revolver);
      p.pop();

      angle -= 0.01;

      p.textFont(font);
      p.textSize(40);
     
      p.fill(0);

      p.push();
      p.translate(0, -(h/2)+(h/12));
      p.textAlign(p.CENTER,p.TOP);
      p.text(a.toUpperCase(), 0, 0);
      p.pop();

      p.push();
      p.translate(0, (h/2)-(h/12));
      p.textAlign(p.CENTER,p.BOTTOM);
      p.text(b.toUpperCase(), 0, 0);
      p.pop();

      //show the results

      ellipses.forEach((ellipse) => {
        p.push();
        p.noStroke();
        p.fill(0);
        p.translate(0, 0, 400);
        p.ellipse(ellipse.x, ellipse.y, 40, 40);
        p.pop();
      });
    

    };

    p.mouseClicked = () => {
      const newEllipse = { x: p.random(-rw/2, rw/2), y: p.random(-h/2, h/2) };
      ellipses.push(newEllipse);
    }

    p.windowResized = () => {
      w = window.innerWidth;
      h = window.innerHeight;
      rw = w * 0.65;
      p.resizeCanvas(rw, h, p.WEBGL);
    };


  };

  
  componentDidMount() {
    //Create p5 canvas once component mounts
    this.p5Canvas = new p5(this.initSketch, this.sketchRef.current);
  }

  componentWillUnmount() {
    this.p5Canvas.remove();
    window.removeEventListener("resize", this.windowResized);
  }

  render() {
    //this div will contain the sketch canvas
    return <div className="mySketch" ref={this.sketchRef} />;
  }
}
